import React from 'react';
import VBInput from "@vb-js-commons/new/vbInput";
import VBTextarea from "@vb-js-commons/new/vbTextarea";
import VBPhoneInput from "@vb-js-commons/new/vbPhoneInput";
import VBMultiOption from "@vb-js-commons/new/vbMultiOption";
import VBDropdown from '@vb-js-commons/new/vbDropdown';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { validatePNR } from '../api.js';
import { TwModal } from '@ui-component-library';
import Cookies from 'js-cookie';

import Navigation from '../components/static/Navigation';
import Footer from '../components/static/Footer.js';

// The state requiredFields is for specific fields you want to show on screen example if you want to show only these:
// requiredFields: ["first_name", "company_name","password"] otherwise the standard list with all fields is shown
class ProfileEditPage extends React.Component {
    constructor() {
        super();
        this.state = {
            errors: {},
            formData: {},
            hasRecurring: Window.react_data.existing_data.has_recurring,
            endSubscriptionFormData: {},
            endSubMessage: '',
            successEndSubModal: false,
            endPrimakundModal: false,
            successModal: false,
            requiredFields: Window.react_data.lists.requiredFields
        }
    }

    handleSubmit(e) {
        e.preventDefault();

        let data = this.state.formData
        let existingData = Window.react_data.existing_data
        let validation = {};

        if (this.state.requiredFields) {
            this.state.requiredFields.forEach((required) => {
                if (required == "first_name" && !data.first_name && !Window.react_data.existing_data.first_name) {
                    validation.first_name = "Förnamn är obligatoriskt."
                }
                if (required == "last_name" && !data.last_name && !Window.react_data.existing_data.last_name) {
                    validation.last_name = "Efternamn är obligatoriskt."
                }
                if (required == "personal_number" && !data.personal_number && !Window.react_data.existing_data.personal_number) {
                    validation.personal_number = "Personnummer du angav är inte korrekt"
                }
                if (required == "mobile_phone_number" && (!data.mobile_phone_number || data.mobile_phone_number.length < 1) && !Window.react_data.existing_data.mobile_phone_number) {
                    validation.mobile_phone_number = "Telefonnumret du angav är inte korrekt";
                }
                if (required == "muni" && (!data.muni || data.muni.length < 1) && !Window.react_data.lists.munis) {
                    validation.muni = "Du måste välja minst en kommun";
                }
                if (required == "Address" && (!data.address) && !Window.react_data.existing_data.address) {
                    validation.address = "Adress är obligatoriskt."
                }
                if (required == "postal_code" && !data.postal_code && !Window.react_data.existing_data.postal_code) {
                    validation.postal_code = "Postnummer är obligatoriskt."
                }
                if (required == "city" && !data.city && !Window.react_data.existing_data.city) {
                    validation.city = "Stad/Ort är obligatoriskt."
                }
                if (required == "company_name" && !data.company_name && !Window.react_data.existing_data.company_name) {
                    validation.company_name = "Företagsnamn är obligatoriskt"
                }
                if (required == "organisation_number" && !data.organisation_number && !Window.react_data.existing_data.organisation_number) {
                    validation.organisation_number = "Organisationsnummer är obligatoriskt."
                }
            })
        }

        if (data.personal_number && !validatePNR(data.personal_number.replace('-', ''))) {
            validation.personal_number = "Personnummer du angav är inte korrekt"
        } else if (!data.personal_number && existingData.personal_number && !validatePNR(existingData.personal_number.replace('-', ''))) {
            validation.personal_number = "Personnummer du angav är inte korrekt"
        }

        if (data.mobile_phone_number && !isValidPhoneNumber(data.mobile_phone_number)) {
            validation.mobile_phone_number = "Telefonnumret du angav är inte korrekt";
        }

        if (Object.keys(validation).length !== 0) {
            window.scrollTo({ top: 0, behavior: 'smooth' })
            this.setState({ errors: validation })
        } else {
            if (Object.keys(data).length !== 0) {
                let target = "/user-api/update/"

                fetch(target, {
                    method: "POST",
                    body: JSON.stringify({ "data": data }),
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRFToken': Cookies.get('csrftoken')
                    },
                }).then(res => {
                    if (res.ok) {
                        if (Window.react_data.next_path) {
                            window.location.href = Window.react_data.next_path
                        } else {
                            this.setState({ successModal: true })
                        }
                    } else {
                        alert('Oops! Något gick fel...')
                    }
                });
            }
        }
    }

    handleSubmitEndPrimakund(e) {
        e.preventDefault()
        
        this.setState({ endPrimakundModal: false })
        let target = "/primakund/end-subscription/"

        fetch(target, {
            method: "POST",
            body: JSON.stringify({ "endSubscription": this.state.endSubscriptionFormData }),
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': Cookies.get('csrftoken')
            },
        }).then(res => {
            if (res.ok) {
                res.json().then(json => {
                    this.setState({ hasRecurring: false, endSubMessage: json.message, successEndSubModal: true })
                });
            } else {
                alert('Oops! Något gick fel...')
            }
        });
    }

    render() {
        let formattedEndDate = '';

        if (Window.react_data && Window.react_data.existing_data && Window.react_data.existing_data.date) {
            formattedEndDate = new Date(Window.react_data.existing_data.date).toLocaleString('sv-SE', { day: 'numeric', month: 'long', year: 'numeric' });
        }
        return (<div className="w-full p-0">
            <div className="bg-white">
                <Navigation />

                {this.state.requiredFields && <div className="bg-supp-forest-green">
                    <div className="container py-6">
                        <h2 className="white fs-4 mb-0">Vi behöver mer information från dig för att du ska kunna fortsätta</h2>
                    </div>
                </div>}

                <section className="container pt-2">
                    <div className="flex flex-wrap justify-center">
                        <div className="w-full lg:w-1/2 lg:px-5">
                        {/* {Window.react_data.existing_data.subscription && <>
                                <h2 className="fs-4">Dina prenumerationer</h2>
                                <h5 className="fs-5 mt-6">
                                    Du är Pluskund
                                    {this.state.hasRecurring ? 
                                        <div>
                                            <b> Förnyas {formattedEndDate}</b>{' '}
                                            <span className="neutral-charcoal mb-0" role="button" onClick={() => this.setState({ endPrimakundModal: true })}>
                                                Avsluta Pluskund
                                            </span>{' '}
                                            eller{' '}
                                            <a href="/primakund/?subscription_length=year&instant_generate=1#klarna_container" className="neutral-charcoal">
                                                Byt till års Pluskund
                                            </a>
                                        </div>
                                     : <b> Avslutas {formattedEndDate}</b> }
                                </h5>
                            </>} */}
                            <form onSubmit={(e) => { this.handleSubmit(e) }} className="my-6">
                                <h2 className="mt-6 fs-5">Kontaktinformation</h2>

                                <div>
                                    {(!this.state.requiredFields || this.state.requiredFields.includes("first_name")) && <VBInput
                                        type="text"
                                        label={<label className='subtitle pb-1'>Förnamn</label>}
                                        initial={Window.react_data?.existing_data?.first_name}
                                        error={this.state.errors.first_name}
                                        onFocus={() => this.setState({errors:{...this.state.errors,first_name:''}})}
                                        onChange={(val) => { this.setState({ formData: { ...this.state.formData, first_name: val } }) }} />}

                                    {(!this.state.requiredFields || this.state.requiredFields.includes("last_name")) && <VBInput
                                        type="text"
                                        label={<label className='subtitle pb-1 mt-6'>Efternamn</label>}
                                        initial={Window.react_data?.existing_data?.last_name}
                                        error={this.state.errors.last_name}
                                        onFocus={() => this.setState({errors:{...this.state.errors,last_name:''}})}
                                        onChange={(val) => {this.setState({ formData: { ...this.state.formData, last_name: val } }) }} />}

                                    {((!this.state.requiredFields || this.state.requiredFields.includes("personal_number")) && !Window.react_data?.existing_data?.bankid_enabled) && <VBInput
                                        type="text"
                                        label={<label className='subtitle pb-1 mt-6'>Personnummer (ÅÅÅÅMMDD-XXXX)</label>}
                                        initial={Window.react_data?.existing_data?.personal_number}
                                        error={this.state.errors.personal_number}
                                        onFocus={() => this.setState({errors:{...this.state.errors,personal_number:''}})}
                                        onChange={(val) => { val=val.replace(/-/g,"");this.setState({ formData: { ...this.state.formData, personal_number: val } }) }} />}

                                    {Window.react_data?.existing_data?.bankid_enabled && !this.state.requiredFields && <>
                                        <label className='subtitle pb-1 mt-6'>Personnummer</label>
                                        <h5 className='font-medium ml-1 fs-6'>{Window.react_data?.existing_data?.personal_number}</h5></>}
                                    
                                    {!this.state.requiredFields && <>
                                        <label className='subtitle pb-1 mt-6'>E-postadress</label>
                                        <h5 className='font-medium ml-1 fs-6'>{Window.react_data?.existing_data?.email}</h5>
                                    </>}

                                    {(!this.state.requiredFields || this.state.requiredFields.includes("mobile_phone_number")) && <VBPhoneInput
                                        label={<label className='subtitle pb-1 mt-6'>Mobilnummer</label>}
                                        initial={Window.react_data?.existing_data?.mobile_phone_number}
                                        error={this.state.errors.mobile_phone_number}
                                        onFocus={() => this.setState({errors:{...this.state.errors,mobile_phone_number:''}})}
                                        onChange={(val) => { this.setState({ formData: { ...this.state.formData, mobile_phone_number: val }, errors:{...this.state.errors, mobile_phone_number:''} }); }} />}

                                    {(!this.state.requiredFields || this.state.requiredFields.includes("muni")) && <>
                                        <h2 className="mt-12 fs-5">Dina aktiva kommuner</h2>
                                            <VBMultiOption
                                            label={<label className='subtitle pb-1 mt-1'>Kommun</label>}
                                            options={Window.react_data?.lists?.munis ? Window.react_data.lists.munis : []}
                                            initial={Window.react_data?.existing_data?.muni}
                                            error={this.state.errors.muni}
                                            onFocus={() => this.setState({errors:{...this.state.errors,muni:''}})}
                                            onChange={(val) => { this.setState({ formData: { ...this.state.formData, muni: val.map(itm => parseInt(itm.value)) } }); }} />
                                    </>}

                                    {(!this.state.requiredFields || this.state.requiredFields.includes('address') || this.state.requiredFields.includes('postal_code') || this.state.requiredFields.includes('city')) &&
                                        <h2 className="mt-12 fs-5">Din hemadress eller företagsadress</h2>}

                                    {(!this.state.requiredFields || this.state.requiredFields.includes("address")) && <VBInput
                                        type="text"
                                        label={<label className='subtitle pb-1 mt-1'>Adress</label>}
                                        initial={Window.react_data?.existing_data?.address}
                                        error={this.state.errors.address}
                                        onFocus={() => this.setState({errors:{...this.state.errors,address:''}})}
                                        onChange={(val) => { this.setState({ formData: { ...this.state.formData, address: val } }) }} />}

                                    {(!this.state.requiredFields || this.state.requiredFields.includes("postal_code")) && <VBInput
                                        type="number"
                                        label={<label className='subtitle pb-1 mt-6'>Postnummer</label>}
                                        initial={Window.react_data?.existing_data?.postal_code}
                                        error={this.state.errors.postal_code}
                                        onFocus={() => this.setState({errors:{...this.state.errors,postal_code:''}})}
                                        onChange={(val) => { this.setState({ formData: { ...this.state.formData, postal_code: val } }) }} />}

                                    {(!this.state.requiredFields || this.state.requiredFields.includes("city")) && <VBInput
                                        type="text"
                                        label={<label className='subtitle pb-1 mt-6'>Stad/ Ort</label>}
                                        initial={Window.react_data?.existing_data?.city}
                                        error={this.state.errors.city}
                                        onFocus={() => this.setState({errors:{...this.state.errors,city:''}})}
                                        onChange={(val) => { this.setState({ formData: { ...this.state.formData, city: val } }) }} />}

                                    {(!this.state.requiredFields || this.state.requiredFields.includes('company_name') || this.state.requiredFields.includes("organisation_number") || this.state.requiredFields.includes("vat_number")) &&
                                        <h2 className='mt-12 fs-5'>Om du är ett företag ange</h2>}

                                    {(!this.state.requiredFields || this.state.requiredFields.includes("company_name")) && <VBInput
                                        type="text"
                                        label={<label className='subtitle pb-1 mt-1'>Företagsnamn</label>}
                                        initial={Window.react_data?.existing_data?.company_name}
                                        error={this.state.errors.company_name}
                                        onFocus={() => this.setState({errors:{...this.state.errors,company_name:''}})}
                                        onChange={(val) => { this.setState({ formData: { ...this.state.formData, company_name: val } }) }} />}

                                    {(!this.state.requiredFields || this.state.requiredFields.includes("organisation_number")) && <VBInput
                                        type="text"
                                        label={<label className='subtitle pb-1 mt-6'>Organisationsnummer (XXXXXX-XXXX)</label>}
                                        initial={Window.react_data?.existing_data?.organisation_number}
                                        error={this.state.errors.organisation_number}
                                        onFocus={() => this.setState({errors:{...this.state.errors,organisation_number:''}})}
                                        onChange={(val) => { this.setState({ formData: { ...this.state.formData, organisation_number: val } }) }} />}

                                    {(!this.state.requiredFields || this.state.requiredFields.includes("vat_number")) && <VBInput
                                        type="text"
                                        label={<label className='subtitle pb-1 mt-6'>VAT-nummer</label>}
                                        initial={Window.react_data?.existing_data?.vat_number}
                                        error={this.state.errors.vat_number}
                                        onFocus={() => this.setState({errors:{...this.state.errors,vat_number:''}})}
                                        onChange={(val) => { this.setState({ formData: { ...this.state.formData, vat_number: val } }) }} />}

                                    <div className="flex flex-wrap mt-6">
                                        <div className={`w-full flex ${this.state.requiredFields ? 'justify-end' : 'justify-between'}`}>
                                            {!this.state.requiredFields && <a href="/forgot-password/" className="supp-pine font-medium fs-6" target="_blank">Byt lösenord?</a>}

                                            <button type="submit" className="n-btn btn-forest-green">{Window.react_data.next_path ? 'Fortsätt' : 'Spara uppgifter'}</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </section>

                <Footer />
            </div>
            
            <TwModal isOpen={this.state.endPrimakundModal} className="bg-primary-dark p-2">
                <TwModal.Header>
                    <div className="flex justify-between items-start">
                        <h2 className="primary-main mb-0">Avsluta prima-prenumeration</h2>
                        <button type="button" className="ml-auto fs-5 leading-none white" onClick={() => this.setState({ endPrimakundModal: false })} aria-label="Close">&times;</button>
                    </div>
                </TwModal.Header>
                <form onSubmit={(e) => { this.handleSubmitEndPrimakund(e) }}>
                    <TwModal.Content>
                        <p className="font-bold white">
                            Är du <span className="font-bold">säker</span> på att du vill <span className=" font-bold">avsluta</span> din prima-prenumeration?
                            Efter du avslutat är du fortfarande Pluskund till och med <span className="font-bold">{formattedEndDate}</span>.
                        </p>
                        <p className="mb-0 white">Vad ger du tjänsten för betyg?</p>
                        <VBDropdown
                            options={Window.react_data.lists.scale_grade}
                            placeholder="Klicka här för att svara"
                            onChange={(val) => { this.setState({ endSubscriptionFormData: { ...this.state.endSubscriptionFormData, scaleGrade: val } }) }} />
                        <p className="mb-0 mt-2 white">Varför valde du att avsluta din prenumeration?</p>
                        <VBDropdown
                            placeholder="Klicka här för att svara"
                            options={Window.react_data.lists.end_reason}
                            onChange={(val) => { this.setState({ endSubscriptionFormData: { ...this.state.endSubscriptionFormData, endingReason: val } }) }} />
                        <p className="mb-0 mt-2 white">Skulle du rekommendera Pluskund?</p>
                        <VBDropdown
                            placeholder="Klicka här för att svara"
                            options={Window.react_data.lists.recommendation}
                            onChange={(val) => { this.setState({ endSubscriptionFormData: { ...this.state.endSubscriptionFormData, recommendation: val } }) }} />
                        <p className="mb-0 mt-2 white">Övriga kommentarer</p>
                        <VBTextarea
                            type="text"
                            rows={4}
                            onChange={(val) => { this.setState({ endSubscriptionFormData: { ...this.state.endSubscriptionFormData, body: val } }) }} />
                    </TwModal.Content>
                    <TwModal.Footer>
                        <div className="flex justify-between">
                            <button type="button" className="n-btn btn-outline btn-sm white" onClick={() => this.setState({ endPrimakundModal: false })}>Stäng</button>
                            <button className='n-btn btn-forest-green btn-sm' type='submit'>Avsluta</button>
                        </div>
                    </TwModal.Footer>
                </form>
            </TwModal>

            <TwModal isOpen={this.state.successModal} className="bg-primary-dark p-2">
                <TwModal.Header>
                    <div className="flex justify-between items-start">
                        <h2 className="primary-main mb-0">LYCKADES</h2>
                        <button type="button" className="ml-auto fs-5 leading-none white" onClick={() => this.setState({ successModal: false, formData: {} })} aria-label="Close">&times;</button>
                    </div>
                </TwModal.Header>
                <TwModal.Content>
                    <p className="white">Din information har sparats.</p>
                </TwModal.Content>
                <TwModal.Footer>
                    <div className="flex justify-end">
                        <button className="n-btn btn-sm" onClick={() => this.setState({ successModal: false, formData: {} })}>Stäng</button>
                    </div>
                </TwModal.Footer>
            </TwModal>

            <TwModal isOpen={this.state.successEndSubModal} className="bg-primary-dark p-2">
                <TwModal.Header>
                    <div className="flex justify-between items-start">
                        <h2 className="primary-main mb-0">LYCKADES</h2>
                        <button type="button" className="ml-auto fs-5 leading-none white" onClick={() => this.setState({ successEndSubModal: false })} aria-label="Close">&times;</button>
                    </div>
                </TwModal.Header>
                <TwModal.Content>
                    <p className="white">{this.state.endSubMessage}</p>
                </TwModal.Content>
                <TwModal.Footer>
                    <div className="flex justify-end">
                        <button className="n-btn btn-sm" onClick={() => this.setState({ successEndSubModal: false })}>Stäng</button>
                    </div>
                </TwModal.Footer>
            </TwModal>
        </div>)
    }
}
export default ProfileEditPage;